// src/config/helmetConfig.js

const BASE_URL = "https://styleemporiumcs.com";
const DEFAULT_OG_IMAGE =
  "https://barber-shop-images.s3.us-east-2.amazonaws.com/38ebdd8e-9ab4-4bb9-a55f-a277ad14571d-StyleEmpOpenGraph.webp";

const DEFAULT_LOGO =
  "https://barber-shop-images.s3.us-east-2.amazonaws.com/db5c6cf8-2cf9-48f9-92b2-c620bad45834-barberPole.png";

export const defaultMeta = {
  title: "The Style Emporium - Colorado Springs",
  description:
    "The Style Emporium - Your premier destination for haircuts, styling, and grooming services in Colorado Springs.",
  keywords:
    "barber shop, hair salon, Colorado Springs, precision cuts, beard services",
  canonical: BASE_URL,
  robots: "index, follow",
  ogImage: DEFAULT_OG_IMAGE,
  ogLogo: DEFAULT_LOGO,
};

export const pageMeta = {
  home: {
    title: "The Style Emporium",
    description:
      "Experience precision cuts, beard services, and vivid color at Colorado Springs' premier barbershop.",
    keywords:
      "barber shop, hair salon, Colorado Springs, precision cuts, beard services, vivid color",
    canonical: BASE_URL,
    ogImage: DEFAULT_OG_IMAGE,
    ogLogo: DEFAULT_LOGO,
  },
  services: {
    title: "The Style Emporium - Our Services",
    description:
      "Discover our full range of barbershop services including haircuts, beard services, color, extensions, and more.",
    keywords:
      "haircuts, beard services, hair color, extensions, Colorado Springs salon services",
    canonical: `${BASE_URL}/services`,
    ogImage: DEFAULT_OG_IMAGE,
    ogLogo: DEFAULT_LOGO,
  },
  team: {
    title: "The Style Emporium - Meet Our Team",
    description:
      "Meet our talented team of barbers and stylists at The Style Emporium in Colorado Springs.",
    keywords:
      "barbers, stylists, hair professionals, Colorado Springs, experienced barbers",
    canonical: `${BASE_URL}/team`,
    ogImage: DEFAULT_OG_IMAGE,
    ogLogo: DEFAULT_LOGO,
  },
  events: {
    title: "The Style Emporium - Events & Workshops",
    description:
      "Join us for styling workshops, charity events, and community gatherings at The Style Emporium.",
    keywords:
      "barbershop events, hair workshops, Colorado Springs events, styling classes",
    canonical: `${BASE_URL}/events`,
    ogImage: DEFAULT_OG_IMAGE,
    ogLogo: DEFAULT_LOGO,
  },
  reviews: {
    title: "The Style Emporium - Customer Reviews",
    description:
      "Read what our fabulous clients say about The Style Emporium. See why we're Colorado Springs' top-rated barbershop and hair salon.",
    keywords:
      "barbershop reviews, salon reviews, Colorado Springs testimonials, hair salon ratings",
    canonical: `${BASE_URL}/reviews`,
    ogImage: DEFAULT_OG_IMAGE,
    ogLogo: DEFAULT_LOGO,
  },
  admin: {
    title: "Admin Dashboard - The Style Emporium",
    robots: "noindex, nofollow",
  },
};

// Helper function to merge with defaults
export const getMetaWithDefaults = (pageMeta = {}) => {
  return {
    ...defaultMeta,
    ...pageMeta,
  };
};
